
import { Component, Vue, Prop } from 'vue-property-decorator';
import LinkableLabel from '../shared/LinkableLabel.vue';

@Component({
    components: {
        LinkableLabel,
    },
})
export default class DropdownRow extends Vue {
    isInvalid = false;

    // label props
    @Prop() labelId!: string;
    @Prop() selectId!: string;
    @Prop() labelText!: string;
    @Prop({ default: false }) hasLink!: boolean;
    @Prop() popoverType!: string;

    // dropdown props
    @Prop() options!: [];
    @Prop() selectedValue!: string;
    @Prop() isRequired!: boolean;
    @Prop() errorMessage!: string;

    mounted() {
        this.$root.$on('resetFields', () => {
            this.isInvalid = false;
        })
    }

    emitUpdates(event: any) {
        this.$emit('select', event.target.value);
    }

    // called when form validation happens and there is an error
    handleInvalid() {
        this.isInvalid = true;
    }
}
